<h4 mat-dialog-title>
  <mat-icon color="primary" style="vertical-align: middle;">event_available</mat-icon>
  {{ 'APPOINTMENT_RELATED.AVAILABLE_DATE' | translate }}
</h4>

<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onConfirm()">{{ 'LABEL.OK' | translate }}</button>
</div>